/* The cart upsell button.

   Delegated from `document` on purpose: the drawer's whole inner HTML is
   replaced by Dawn after every cart change, so a listener bound to the button
   itself would be thrown away on the first render. Delegation survives that.

   The add goes through /cart/add.js requesting the cart sections back -- the
   same request Dawn's own product form makes -- and the response is handed to
   Dawn's renderer. Nothing here reaches into the drawer's markup directly, so
   apps that listen for cart changes see an ordinary add and the progress bar
   above recomputes itself in Liquid on the next render. */

(function () {
  if (window.__fancoCartReady) return;
  window.__fancoCartReady = true;

  var SECTIONS = ['cart-drawer', 'cart-icon-bubble', 'cart-items', 'cart-live-region-text'];

  function cartTarget() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function sectionsToRequest() {
    var cart = cartTarget();
    if (cart && typeof cart.getSectionsToRender === 'function') {
      return cart.getSectionsToRender().map(function (s) {
        return s.id;
      });
    }
    return SECTIONS;
  }

  function setBusy(button, busy) {
    var label = button.querySelector('.fanco-upsell__add-label');
    var spinner = button.querySelector('.fanco-upsell__spinner');
    button.disabled = busy;
    if (label) label.hidden = busy;
    if (spinner) spinner.hidden = !busy;
  }

  function showError(root, message) {
    var box = root.querySelector('.fanco-upsell__error');
    if (!box) return;
    box.textContent = message;
    box.hidden = !message;
  }

  // The "?" bubble next to the shipping note is a <details>, so opening it
  // needs nothing. Closing it when the shopper taps anywhere else, or presses
  // Escape, does.
  function closeTips(except) {
    document.querySelectorAll('[data-fanco-tip][open]').forEach(function (tip) {
      if (tip !== except) tip.removeAttribute('open');
    });
  }

  document.addEventListener('click', function (event) {
    closeTips(event.target.closest('[data-fanco-tip]'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeTips(null);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-fanco-upsell-add]');
    if (!button) return;

    event.preventDefault();

    var root = button.closest('[data-fanco-upsell]');
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    showError(root, '');
    setBusy(button, true);

    var body = {
      items: [{ id: Number(variantId), quantity: 1 }],
      sections: sectionsToRequest(),
      sections_url: window.location.pathname
    };

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        // Shopify answers a refused line with a body carrying `status`.
        if (data.status) {
          showError(root, data.description || data.message || 'לא הצלחנו להוסיף את הפריט.');
          setBusy(button, false);
          return;
        }

        var cart = cartTarget();
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(data);
        } else {
          window.location.reload();
        }

        // Tell the rest of the theme, and any app listening, the same way
        // Dawn's product form does.
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'fanco-cart-upsell',
            cartData: data
          });
        }
      })
      .catch(function () {
        showError(root, 'משהו השתבש. נסו שוב.');
        setBusy(button, false);
      });
  });
})();
